import {
  a175,
  a217,
  a756,
  a757,
  a759,
  a760,
  a764,
  a765,
  a766,
  a768,
  an181,
} from "Components/Api/RootApiPath";

export const addStocks = async ({ payload }) => {
  console.log(payload);
  try {
    const data = await fetch(a756, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(`${response.statusText || "Failed to add stock"}`);
    }
    return data?.json();
  } catch (e) {
    console.log(e);
    throw new Error(`${"Failed to add stock, try again later"}`);
  }
};

export const addStockImages = async ({ payload }) => {
  console.log(payload);
  try {
    const data = await fetch(a765, {
      method: "POST",
      body: payload,
    });
    if (!data.ok) {
      throw new Error(`${response.statusText || "Failed to upload images"}`);
    }
    return data?.json();
  } catch (e) {
    console.log(e);
    throw new Error(`${"Failed to upload images, try again later"}`);
  }
};

export const updateLabelledStock = async ({ payload }) => {
  console.log(payload);
  try {
    const data = await fetch(a760, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(`${response.statusText || "Failed to update stock"}`);
    }
    return data?.json();
  } catch (e) {
    console.log(e);
    throw new Error(`${"Failed to update stock, try again later"}`);
  }
};
export const deleteImage = async({payload})=>{
  console.log(payload);
  try {
    const data = await fetch(a766, {
      method: "POST",
      // headers: {
      //   "Content-Type": "application/json",
      // },
      body: payload,
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(`${response.statusText || "Failed to delete stock image"}`);
    }
    return data?.json();
  } catch (e) {
    console.log(e);
    throw new Error(`${"Failed to delete stock image, try again later"}`);
  }
}

export const getLabelledStocks = async ({ queryKey }) => {
  const [, clientCode] = queryKey;

  try {
    const data = await fetch(an181, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch all stock list"}`
      );
    }
    return data?.json();
  } catch (e) {
    console.log(e);
    throw new Error(`${"Failed to fetch all stock list, try again later"}`);
  }
};

export const fetchBulkStocks = async({payload})=>{
  console.log(payload);
  const {clientCode,TIDNumbers} = payload
  try {
    const data = await fetch(a768, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
        TIDNumbers: TIDNumbers,
      }),
    });
    if (!data.ok) {
      throw new Error(`${response.statusText || "Failed to fetch bulk stocks"}`);
    }
    return data?.json();
  } catch (e) {
    console.log(e);
    throw new Error(`${"Failed to fetch bulk stocks, try again later"}`);
  }
}

export const getLabelledStockById = async ({ clientCode, id }) => {
  try {
    const data = await fetch(a757, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
        Id: id,
      }),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(`${response.statusText || "Failed to add stock"}`);
    }
    return data?.json();
  } catch (e) {
    console.log(e);
    throw new Error(`${"Failed to add stock, try again later"}`);
  }
};

export const getStockImagesById = async ({ clientCode, itemCode }) => {
  const formData = new FormData()
  formData.append("ClientCode",clientCode)
  formData.append("ItemCode",itemCode)
  try {
    const data = await fetch(a764, {
      method: "POST",
      // headers: {
      //   "Content-Type": "application/json",
      // },
      body: formData,
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(`${response.statusText || "Failed to add stock"}`);
    }
    return data?.json();
  } catch (e) {
    console.log(e);
    throw new Error(`${"Failed to add stock, try again later"}`);
  }
};

export const getAllTemplateList = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a757, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch template list"}`
      );
    }
    return data?.json();
  } catch (e) {
    console.log(e);
    throw new Error(`${"Failed to fetch template list, try again later"}`);
  }
};

export const fetchLabelledStocks = async ({ queryKey }) => {
  const [, clientCode,CategoryId,ProductId,DesignId,FromDate,ToDate,Content,PageNumber,
    PageSize] = queryKey;
    try {
      const data = await fetch(a759, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ClientCode: clientCode,
          CategoryId:CategoryId,
          ProductId:ProductId,
          DesignId:DesignId,
          FromDate:FromDate,
          ToDate:ToDate,
          Content:Content,
          PageNumber:PageNumber,
          PageSize  :PageSize
        }),
      });
      console.log(data);
      if (!data.ok) {
        throw new Error(
          `${response.statusText || "Failed to fetch all stock list"}`
        );
      }
      return data?.json();
    } catch (e) {
      console.log(e);
      throw new Error(`${"Failed to fetch all stock list, try again later"}`);
    }
  };


export const fetchAllRfidData = async ({ queryKey }) => {
  const [, clientCode] = queryKey;

  try {
    const data = await fetch(a175, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch all rfid data"}`
      );
    }
    return data?.json();
  } catch (e) {
    console.log(e);
    throw new Error(`${"Failed to fetch all rfid data, try again later"}`);
  }
};
